import React, { FC } from 'react';
import { Toast as TPAToast, TOAST_PLACEMENT } from 'wix-ui-tpa/Toast';
import { useEnvironment, useTranslation } from '@wix/yoshi-flow-editor';

import { useUI, useUIHandlers } from '../../../../../contexts/widgets';
import { getToastContent } from './getToastContent';
import { classes, st } from './Toast.st.css';

export const Toast: FC = () => {
  const { t } = useTranslation();
  const { isMobile } = useEnvironment();
  const { toast } = useUI();
  const { hideToast } = useUIHandlers();

  const { toastContent, toastSkin } = getToastContent(toast.type, t);

  return (
    <TPAToast
      className={st(classes.toast, {
        mobile: isMobile,
        displayNone: !toast.isVisible,
      })}
      skin={toastSkin}
      placement={
        isMobile ? TOAST_PLACEMENT.bottomFullWidth : TOAST_PLACEMENT.inline
      }
      children={toastContent}
      isShown={toast.isVisible}
      shouldShowCloseButton={true}
      onClose={() => hideToast()}
    />
  );
};
